import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Flex, Image, mode, Text, useColorMode } from '@abb/uikit';
import { ChevronRight } from '@abb/uikit/icons/outline/arrow';
import { Check, Translate02 } from '@abb/uikit/icons/outline/general';
import Gleap from 'gleap';
import { useDependencies } from 'hooks';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderResponsive } from './HeaderResponsive';
const language = {
    az: 'Azərbaycanca',
    en: 'English',
    ru: 'Русский'
};
export const LanguageResponsive = (param)=>{
    let { onSidebarOpen } = param;
    var _languageService_languagesList;
    const { t } = useTranslation('common');
    const [open, setOpen] = useState(false);
    const { colorMode } = useColorMode();
    const onCloseDrower = ()=>{
        setOpen(false);
        onSidebarOpen();
    };
    const { languageService } = useDependencies();
    const enIcon = useRef(null);
    const ruIcon = useRef(null);
    const azIcon = useRef(null);
    const handleSelectOption = (lang)=>{
        languageService === null || languageService === void 0 ? void 0 : languageService.setLanguage(lang);
        Gleap.setLanguage(lang);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Flex, {
                p: "12px 24px",
                onClick: ()=>setOpen(!open),
                w: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        alignItems: "center",
                        gap: 3,
                        children: [
                            /*#__PURE__*/ _jsx(Translate02, {
                                w: "20px",
                                h: "20px"
                            }),
                            /*#__PURE__*/ _jsxs(Box, {
                                textAlign: "start",
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: t('user_settings.language_select')
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "14px",
                                        color: "#7A7D82",
                                        children: language[languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ChevronRight, {})
                ]
            }),
            open && /*#__PURE__*/ _jsxs(Box, {
                borderRadius: "24px",
                p: 3,
                bg: mode('#F0F0F0', '#0A0B0D')({
                    colorMode
                }),
                position: "fixed",
                zIndex: 2,
                top: "0",
                left: 0,
                h: "calc(100dvh - 16px)",
                w: "100%",
                children: [
                    /*#__PURE__*/ _jsx(HeaderResponsive, {
                        onCloseSidebar: onCloseDrower,
                        responsiveSetOpenModal: setOpen,
                        responsiveOpenModal: open
                    }),
                    languageService === null || languageService === void 0 ? void 0 : (_languageService_languagesList = languageService.languagesList) === null || _languageService_languagesList === void 0 ? void 0 : _languageService_languagesList.map((lang, index)=>{
                        return /*#__PURE__*/ _jsxs(Flex, {
                            onClick: ()=>handleSelectOption(lang),
                            borderRadius: "12px",
                            justifyContent: "space-between",
                            bg: (languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage) === lang ? mode('#0A0B0D0A', '#FFFFFF0A')({
                                colorMode
                            }) : 'transparent',
                            p: 3,
                            w: "100%",
                            gap: 3,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    gap: 3,
                                    children: [
                                        /*#__PURE__*/ _jsx(Image, {
                                            ref: lang === 'en' ? enIcon : lang === 'ru' ? ruIcon : azIcon,
                                            id: lang === 'en' ? 'en-icon' : lang === 'ru' ? 'ru-icon' : 'az-icon',
                                            src: `/flags/${lang}.png`,
                                            w: "24px",
                                            h: "24px",
                                            borderRadius: "50%"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: language[`${lang}`]
                                        })
                                    ]
                                }),
                                (languageService === null || languageService === void 0 ? void 0 : languageService.currentLanguage) === lang && /*#__PURE__*/ _jsx(Check, {})
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
};
